<template>
    <div class="container">
      <div class="nav-top fix">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">用户协议</div>
        <div class="nav-right">
          <span class="nav-lable"></span>
          <img src="../../assets/img/更换.png" class="nav-img none" />
        </div>
      </div>
  
      <div class="content">
        <p>重要须知</p>
        <p>欢迎使用《小火柴：小火柴社交应用》软件产品及相关各项服务(下称“本应用产品”或”小火柴社交应用“)。您(下称“用户”)在使用之前，请仔细阅读本《最终用户使用许可协议》(下称“本协议”)中的所有内容(未成年人应当在监护人陪同下阅读)，特别是其中免除或者限制锦盛长欣科技有限公司责任的免责条款和对用户的权利限制条款。如您不同意本协议的任何条款内容，请不要注册及(或)使用(包括继续使用)小火柴社交应用，否则您的注册及(或)使用(包括继续使用)行为将被视为您已仔细阅读并充分理解本协议的所有内容，同意并接受本协议全部条款的约定，本协议即构成您与锦盛长欣科技有限公司之间就您使用本应用产品所达成的协议，具有法律效力。此后您不得以未阅读本协议内容或类似言辞做任何形式的抗辩。</p>
        <p>1、用户使用规则</p>
        <p>1.1使用小火柴社交应用，用户必须：</p>
        <p>(1)认真阅读并知晓小火柴社交应用的产品介绍，遵守本协议和相关操作规则;</p>
        <p>(2)提供设备，如个人电脑、手机或其他上网设备;</p>
        <p>(3)个人上网和支付与此服务有关的费用;</p>
        <p>(4)遵守中华人民共和国相关法律法规(如果用户是中华人民共和国境外的使用者，还应遵守所属国家或地区的法律法规)。</p>
        <p>1.2 用户在在使用小火柴社交应用时，不得利用小火柴社交应用制作、复制、发布、传播以下信息或指向该等信息的链接及二维码：</p>
        <p>(1)含有侵犯他人知识产权、肖像权、名誉权、隐私权等合法权益的信息的;</p>
        <p>(2)违反宪法确定的基本原则的;</p>
        <p>(3)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;</p>
        <p>(4)损害国家荣誉和利益的;</p>
        <p>(5)煽动民族仇恨、民族歧视，破坏民族团结的;</p>
        <p>(6)破坏国家宗教政策，宣扬邪教和封建迷信的;</p>
        <p>(7)散布谣言，扰乱社会秩序，破坏社会稳定的;</p>
        <p>(8)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的;</p>
        <p>(9)侮辱或者诽谤他人，侵害他人合法权益的;</p>
        <p>(10)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的;</p>
        <p>(11)以非法民间组织名义活动的;</p>
        <p>(12)含有法律、行政法规禁止的其他内容的。</p>
        <p>1.3 用户应保证不得从事下列行为：</p>
        <p>(1)修改、翻译、注释、改编、整理、演绎小火柴社交应用软件产品;</p>
        <p>(2)复制、翻拷、传播和陈列本应用产品的程序、使用手册和(或)其他图文音像资料的全部或部分内容;</p>
        <p>(3)通过反向工程、反向编译、反汇编或其他任何手段对小火柴社交应用软件产品进行分析、修改、攻击、衍生;</p>
        <p>(4)通过任何方式探测、拦截、获取、使用小火柴社交应用软件产品源代码及/或存储于小火柴社交应用中的任何信息;</p>
        <p>(5)创作小火柴社交应用的派生、衍生作品;</p>
        <p>(6)删除、掩盖或更改锦盛长欣科技有限公司或任何第三方的版权声明、商标或其它知识产权声明;</p>
        <p>(7)删除、掩盖或更改小火柴社交应用所展现的任何信息;</p>
        <p>(8)利用小火柴社交应用可能存在的技术缺陷或漏洞而以任何形式为自己或他人谋利或者从事其他不正当行为;</p>
        <p>(9)使用任何方式或方法、试图攻击提供小火柴社交应用软件产品及相关各项服务的相关服务器、路由器、交换机以及其他设备，以达到非法获得或修改未经授权的数据资料、影响正常的小火柴社交应用服务秩序，以及其他危害性目的的行为;</p>
        <p>(10)通过异常或者非法方法使用小火柴社交应用软件产品及其相关各项服务，恶意破坏小火柴社交应用软件产品，扰乱正常的服务秩序或者实施其他不正当行为;</p>
        <p>(11)制作、发布、传播、使用任何形式的妨碍小火柴社交应用相关各项服务的辅助工具或程序;</p>
        <p>(12)盗取或使用他人账号或密码登录/使用小火柴社交应用;</p>
        <p>(13)任何方式破坏、干扰小火柴社交应用软件产品及其相关各项服务，或影响锦盛长欣科技有限公司品牌形象、公司利益的行为。</p>
        <p>1.4 用户在使用小火柴社交应用时，不得损害、禁用、影响锦盛长欣科技有限公司的其他服务或使锦盛长欣科技有限公司的其他服务负担过重，也不得影响任何其它方享用锦盛长欣科技有限公司的其他服务。如果用户对小火柴社交应用有任何意见，或有如何改进的建议，可向锦盛长欣科技有限公司提出。请注意，如果这样做，还会授予锦盛长欣科技有限公司和第三方在小火柴社交应用(或第三方软件)中无偿使用和加入用户的建议或意见的权利。</p>
        <p>2、相关服务</p>
        <p>2.1 小火柴社交应用的相关各项服务的具体内容由锦盛长欣科技有限公司根据实际情况提供，锦盛长欣科技有限公司有权随时根据小火柴社交应用的运营情况对该等服务进行任何形式的变动、调整，并且锦盛长欣科技有限公司有权针对小火柴社交应用所涉及的某种特定的服务的服务内容、服务方式通过任何形式(包括但不限于系统/网页公告、系统通知等)作出声明、通知，该等声明、通知将被视为是本协议的一部分。在该等声明、通知发布后，用户如继续使用小火柴社交应用，则视为用户已知悉并同意该等声明、通知的内容。</p>
        <p>2.2小火柴社交应用保留/持有将部分服务设定为收费的网络服务的权利，如小火柴社交应用开通任何收费网络服务，则用户使用收费网络服务时需要支付一定的费用。对于收费的网络服务，锦盛长欣科技有限公司会在用户使用之前给予用户明确的提示，只有用户根据提示确认其愿意支付相关费用，用户才能使用该等收费网络服务。如用户拒绝支付相关费用，则锦盛长欣科技有限公司有权不向用户提供该等收费网络服务。</p>
        <p>3、注册资料及数据信息</p>
        <p>3.1用户在申请成为小火柴社交应用的注册用户时，锦盛长欣科技有限公司有权基于安全运营、社会公共安全的需要或国家政策法规的要求，要求用户提供详尽、合法、准确的个人信息资料，如用户提供给锦盛长欣科技有限公司的资料不准确、不真实、不合法有效并导致锦盛长欣科技有限公司做出错误判断的，锦盛长欣科技有限公司有权终止用户继续使用小火柴社交应用的权利，并追究用户的法律责任。</p>
        <p>3.2 用户同意与注册、使用小火柴社交应用所相关的一切资料、数据和记录，包括但不限于注册信息、和相关的使用统计数据归锦盛长欣科技有限公司所有(用户的姓名、身份证号、电话号码等个人身份数据信息除外)。发生争议时，用户同意以锦盛长欣科技有限公司的系统数据为准，锦盛长欣科技有限公司保证该数据的真实性。</p>
        <p>4、仅供个人使用</p>
        <p>4.1 在用户同意并接受本协议全部条款的前提下，锦盛长欣科技有限公司同意授予用户可撤销的、可变更的、非专有的、不可转让和不可再授权的、仅限于个人使用用途的使用小火柴社交应用软件产品及相关各项服务的权利。</p>
        <p>4.2 除非经锦盛长欣科技有限公司事先授权，用户不得将小火柴社交应用用于任何商业用途，不得利用或通过小火柴社交应用进行任何的牟利行为。用户如果要通过、利用小火柴社交应用、对小火柴社交应用或者与小火柴社交应用有关或派生的任何资料、服务或软件进行任何商业性使用，则应与锦盛长欣科技有限公司联系并获得锦盛长欣科技有限公司的另行授权。</p>
        <p>5、知识产权</p>
        <p>5.1 锦盛长欣科技有限公司依法享有小火柴社交应用的一切合法权属(包括但不限于知识产权)。小火柴社交应用软件产品及其相关各项服务的全部著作权及一切其他知识产权，以及与小火柴社交应用相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图标、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等</p>

      </div>
        
    </div>
  </template>
    
    <script>
  export default {
    data() {
      return {};
    },
    mounted() {
      this.init_page();
    },
    methods: {
      back() {
        this.$router.go(-1); //返回上一层
      },
      init_page() {
        
      },
    },
  };
  </script>
    
    <style lang="scss" scoped>
  .container {
    min-height: 100vh;
    background-color: #efefef;
  }
 
  </style>